export enum BiRealtimeBonusesAttributes {
    ActiveBonuses = "ACTIVE_BONUSES",
    AttachedBonuses = "ATTACHED_BONUSES",
    PartiallyCompeletedBonuses = "PARTIALLY_COMPLETED_BONUSES",
    CompletedBonuses = "COMPLETED_BONUSES",
    BonusDenied = "BONUS_DENIED",
    PanicButton = "PANIC_BUTTON",
}

export interface BiRealtimeBonusesResponse {
    // every atribute has different property
    Attributes: [];
}
